// libs
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.scss';

// Props and Context
const propTypes = {
  color: PropTypes.oneOf(['dark', 'light']),
  recommendationCount: PropTypes.number,
};

const defaultProps = {
  color: 'light',
  recommendationCount: 0,
};

const contextTypes = {
  t: PropTypes.func,
};

function Recommendation(props) {
  const { color, recommendationCount } = props;
  const showRecommendationCount = recommendationCount > 0;
  return (
    <span
      className={classNames(
        'recommendation',
        `recommendation--${color}`, {
        'recommendation--fill': showRecommendationCount,
      })}
    >
      {showRecommendationCount && <span>{recommendationCount}</span>}
    </span>
  );
}

Recommendation.contextTypes = contextTypes;
Recommendation.propTypes = propTypes;
Recommendation.defaultProps = defaultProps;

export default Recommendation;



// WEBPACK FOOTER //
// ./src/app/components/cards/card/parts/recommendation/Recommendation.js